import {
  fetchDeleteMessage,
  TDeleteMessageRequest,
  TDeleteMessageResponse,
} from '../repositories/chats/v1/delete-message';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

type TFetchDeleteMessageParams = {
  parameters: TDeleteMessageRequest;
  cookies?: string;
};

const DEFAULT_ERROR_MESSAGE = 'Ошибка при удалении сообщения';

export async function performDeleteMessage(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchDeleteMessageParams,
): Promise<boolean> {
  try {
    const { response, statusCode }: TDeleteMessageResponse = await fetchDeleteMessage({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Messages,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return true;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Messages,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/delete-message/',
      parameters: JSON.stringify(parameters),
    });

    return false;
  }
}
